import * as Cart from '@shopify/theme-cart';

const STORAGE_CART_KEY = 'bl-cart';

function getDefaultRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
      },
    })
  );
}

function fetchJSON(url, config) {
  return fetch(url, config).then((response) => {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

/**
 * Add new line items to the cart
 * @param {array.<{id: Number, quantity: Number, properties: object}>} items
 * Array of objects to pass to /cart/add.js
 * @returns {Promise} Resolves with the line items objects
 */
const addItems = (items) => {
  const config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    items,
  });

  return fetchJSON('/cart/add.js', config);
};

const updateItems = (items) => {
  const config = getDefaultRequestConfig();
  const updates = {};

  items.forEach((item) => {
    updates[item.key] = item.quantity;
  });

  config.method = 'POST';
  config.body = JSON.stringify({
    updates,
  });

  return fetchJSON('/cart/update.js', config);
};

const convertCartToString = (cart) => {
  if (!cart) {
    return '';
  }

  let result = '';

  try {
    result = JSON.stringify(cart);
  } catch (e) {
    console.error(e);
  }

  return result;
};

const initCacheCart = () =>
  new Promise((resolve) => {
    const cachedCartJson =
      window.sessionStorage?.getItem(STORAGE_CART_KEY) || null;

    if (cachedCartJson) {
      return resolve(JSON.parse(cachedCartJson));
    }

    Cart.getState().then((cart) => {
      if (cart) {
        window.sessionStorage?.setItem(
          STORAGE_CART_KEY,
          convertCartToString(cart)
        );

        return resolve(cart);
      }

      return null;
    });

    return null;
  });

const cacheCart = (cart) => {
  if (cart !== undefined) {
    window.sessionStorage?.setItem(STORAGE_CART_KEY, convertCartToString(cart));
  }

  return JSON.parse(window.sessionStorage?.getItem(STORAGE_CART_KEY) || null);
};

const { getState, removeItem, updateItem, updateNote } = Cart;

export {
  addItems,
  updateItems,
  initCacheCart,
  cacheCart,
  getState,
  removeItem,
  updateItem,
  updateNote,
};
